<template>
  <div>
    <div class="form__success" v-if="form.submitStatus === 'OK'">
      <h1><i class="fal fa-check-circle"></i></h1>
      <h2>Publisher Updated</h2>
    </div>
    <form
      class="form"
      @submit.prevent="submit"
      v-if="form.submitStatus !== 'OK'"
    >
      <Field label="Name" type="black">
        <TextInput
          v-model.trim="$v.form.name.$model"
          placeholder="Publisher name"
        />
      </Field>

      <Field label="Short Url" type="black">
        <TextInput
          v-model.trim="$v.form.shorturl.$model"
          placeholder="publisher-name"
        />
      </Field>

      <Field label="Image" type="black">
        <FileInput v-model.trim="$v.form.image.$model" />
      </Field>

      <Field>
        <ButtonSubmit type="secondary">
          Submit
        </ButtonSubmit>
      </Field>
    </form>
  </div>
</template>

<script>
import { required, requiredIf, email } from 'vuelidate/lib/validators';
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    publisherId: String
  },
  data: () => {
    return {
      id: null,
      form: {
        name: '',
        shorturl: '',
        image: null,
        submitStatus: null
      }
    };
  },
  computed: {
    ...mapGetters({
      getPublisher: 'publisher/getPublisher'
    })
  },
  validations: {
    form: {
      name: {
        required
      },
      shorturl: {
        required
      },
      image: {}
    }
  },
  methods: {
    ...mapActions({
      addPublisher: 'publisher/addPublisher',
      editPublisher: 'publisher/editPublisher'
    }),
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.form.submitStatus = 'ERROR';
      } else {
        this.form.submitStatus = 'OK';
        this.$emit('onSubmit');

        if (this.editMode) {
          this.editPublisher(this.form);
        } else {
          this.addPublisher(this.form);
        }
      }
    }
  },
  watch: {
    publisherId: {
      immediate: true,
      handler(value) {
        this.id = value;
        if (this.id) {
          this.editMode = true;
          this.publisher = this.getPublisher(this.id);
          this.form.id = this.publisher.id;
          this.form.name = this.publisher.name;
          this.form.shorturl = this.publisher.shorturl;
          this.form.image = this.publisher.image;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form__success {
  padding: $padding 0;
  text-align: center;

  h1 {
    color: $secondary;
    font-size: 4.8rem;
  }

  h2 {
    color: $primary;
    font-size: 2.4rem;
    font-weight: 400;
  }
}
</style>
